import { Component, OnInit } from '@angular/core';

@Component({

  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.log("I AM HERE IN THE CONTACT FORM COMPONENT JIJIJIJIJIJIJIJ")
  }

}
